import * as React from "react";
import type { SVGProps } from "react";
const SvgImgUser = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}><path style={{
    color: "#000000",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: "normal",
    fontStretch: "normal",
    fontSize: "medium",
    lineHeight: "normal",
    fontFamily: "sans-serif",
    fontVariantLigatures: "normal",
    fontVariantPosition: "normal",
    fontVariantCaps: "normal",
    fontVariantNumeric: "normal",
    fontVariantAlternates: "normal",
    fontVariantEastAsian: "normal",
    fontFeatureSettings: "normal",
    fontVariationSettings: "normal",
    textIndent: 0,
    textAlign: "start",
    textDecoration: "none",
    textDecorationLine: "none",
    textDecorationStyle: "solid",
    textDecorationColor: "#000000",
    letterSpacing: "normal",
    wordSpacing: "normal",
    textTransform: "none",
    direction: "ltr",
    textOrientation: "mixed",
    dominantBaseline: "auto",
    baselineShift: "baseline",
    textAnchor: "start",
    whiteSpace: "normal",
    shapeMargin: 0,
    inlineSize: 0,
    clipRule: "nonzero",
    display: "inline",
    overflow: "visible",
    visibility: "visible",
    isolation: "auto",
    mixBlendMode: "normal",
    colorInterpolation: "sRGB",
    colorInterpolationFilters: "linearRGB",
    vectorEffect: "none",
    fill: "#000000",
    fillOpacity: 1,
    fillRule: "nonzero",
    strokeWidth: 0,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeOpacity: 1,
    colorRendering: "auto",
    imageRendering: "auto",
    shapeRendering: "auto",
    textRendering: "auto",
    stopColor: "#000000",
    stopOpacity: 1,
    stroke: "none",
    opacity: 1
  }} d="M 12,13 C 9.769381,13.069594 7.4933065,13.570587 5.5648984,14.725617 4.6831192,15.256912 3.8832862,16.17705 4,17.271529 V 20 H 20 C 19.9808,18.878703 20.04068,17.752534 19.96569,16.634641 19.638523,15.239603 18.214306,14.512617 17.00125,14.0025 15.411729,13.386893 13.706,13.028877 12,13 Z" /><path style={{
    color: "#000000",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: "normal",
    fontStretch: "normal",
    fontSize: "medium",
    lineHeight: "normal",
    fontFamily: "sans-serif",
    fontVariantLigatures: "normal",
    fontVariantPosition: "normal",
    fontVariantCaps: "normal",
    fontVariantNumeric: "normal",
    fontVariantAlternates: "normal",
    fontVariantEastAsian: "normal",
    fontFeatureSettings: "normal",
    fontVariationSettings: "normal",
    textIndent: 0,
    textAlign: "start",
    textDecoration: "none",
    textDecorationLine: "none",
    textDecorationStyle: "solid",
    textDecorationColor: "#000000",
    letterSpacing: "normal",
    wordSpacing: "normal",
    textTransform: "none",
    direction: "ltr",
    textOrientation: "mixed",
    dominantBaseline: "auto",
    baselineShift: "baseline",
    textAnchor: "start",
    whiteSpace: "normal",
    shapeMargin: 0,
    inlineSize: 0,
    clipRule: "nonzero",
    display: "inline",
    overflow: "visible",
    visibility: "visible",
    isolation: "auto",
    mixBlendMode: "normal",
    colorInterpolation: "sRGB",
    colorInterpolationFilters: "linearRGB",
    vectorEffect: "none",
    fill: "#000000",
    fillOpacity: 1,
    fillRule: "nonzero",
    strokeWidth: 0,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeOpacity: 1,
    colorRendering: "auto",
    imageRendering: "auto",
    shapeRendering: "auto",
    textRendering: "auto",
    stopColor: "#000000",
    stopOpacity: 1,
    stroke: "none",
    opacity: 1
  }} d="M 12,4 C 9.9744635,3.9513859 8.1196338,5.6692728 8.0116582,7.6921284 7.8129012,9.6745351 9.3245773,11.62839 11.29171,11.937552 13.21284,12.325565 15.27627,11.071501 15.820242,9.1897974 16.442287,7.3286528 15.450787,5.1236725 13.646516,4.3532132 13.131203,4.1196833 12.565628,3.9993516 12,4 Z" /><path style={{
    color: "#000000",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: "normal",
    fontStretch: "normal",
    fontSize: "medium",
    lineHeight: "normal",
    fontFamily: "sans-serif",
    fontVariantLigatures: "normal",
    fontVariantPosition: "normal",
    fontVariantCaps: "normal",
    fontVariantNumeric: "normal",
    fontVariantAlternates: "normal",
    fontVariantEastAsian: "normal",
    fontFeatureSettings: "normal",
    fontVariationSettings: "normal",
    textIndent: 0,
    textAlign: "start",
    textDecoration: "none",
    textDecorationLine: "none",
    textDecorationStyle: "solid",
    textDecorationColor: "#000000",
    letterSpacing: "normal",
    wordSpacing: "normal",
    textTransform: "none",
    direction: "ltr",
    textOrientation: "mixed",
    dominantBaseline: "auto",
    baselineShift: "baseline",
    textAnchor: "start",
    whiteSpace: "normal",
    shapeMargin: 0,
    inlineSize: 0,
    clipRule: "nonzero",
    display: "inline",
    overflow: "visible",
    visibility: "visible",
    opacity: 1,
    isolation: "auto",
    mixBlendMode: "normal",
    colorInterpolation: "sRGB",
    colorInterpolationFilters: "linearRGB",
    vectorEffect: "none",
    fill: "#ffffff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 0,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeOpacity: 1,
    colorRendering: "auto",
    imageRendering: "auto",
    shapeRendering: "auto",
    textRendering: "auto",
    stopColor: "#000000",
    stopOpacity: 1
  }} d="m 11.999059,13.955228 c 2.143479,0.07557 4.325215,0.816425 6.179933,2.425189 0.530064,0.330366 0.643192,1.097716 0.577805,1.843891 0.09093,0.583427 -0.05696,0.817123 -0.458731,0.679023 H 5.2413217 c 0.038626,-0.617753 -0.085997,-1.291988 0.079605,-1.865809 0.8981925,-1.341827 2.202642,-1.863389 3.3975287,-2.40031 1.0693577,-0.416349 2.1723036,-0.67781 3.2806036,-0.681984 z" /><path style={{
    color: "#000000",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: "normal",
    fontStretch: "normal",
    fontSize: "medium",
    lineHeight: "normal",
    fontFamily: "sans-serif",
    fontVariantLigatures: "normal",
    fontVariantPosition: "normal",
    fontVariantCaps: "normal",
    fontVariantNumeric: "normal",
    fontVariantAlternates: "normal",
    fontVariantEastAsian: "normal",
    fontFeatureSettings: "normal",
    fontVariationSettings: "normal",
    textIndent: 0,
    textAlign: "start",
    textDecoration: "none",
    textDecorationLine: "none",
    textDecorationStyle: "solid",
    textDecorationColor: "#000000",
    letterSpacing: "normal",
    wordSpacing: "normal",
    textTransform: "none",
    direction: "ltr",
    textOrientation: "mixed",
    dominantBaseline: "auto",
    baselineShift: "baseline",
    textAnchor: "start",
    whiteSpace: "normal",
    shapeMargin: 0,
    inlineSize: 0,
    clipRule: "nonzero",
    display: "inline",
    overflow: "visible",
    visibility: "visible",
    opacity: 1,
    isolation: "auto",
    mixBlendMode: "normal",
    colorInterpolation: "sRGB",
    colorInterpolationFilters: "linearRGB",
    vectorEffect: "none",
    fill: "#ffffff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 0,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeOpacity: 1,
    colorRendering: "auto",
    imageRendering: "auto",
    shapeRendering: "auto",
    textRendering: "auto",
    stopColor: "#000000",
    stopOpacity: 1
  }} d="m 11.996656,5.1457605 c 1.847128,-0.066227 3.342742,1.9541783 2.725378,3.7006076 C 14.247786,10.565783 12.014517,11.425548 10.519515,10.439542 8.9624595,9.5687821 8.6700344,7.1993067 9.9808347,5.9841992 10.507694,5.452944 11.247598,5.1418838 11.996656,5.1457605 Z" /></svg>;
export default SvgImgUser;